import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function SloganMarquee() {
  const slogans = ['Turning Happy Customers Into 5-Star Reviews', 'Helping Local Businesses Get Found & Trusted', 'More Reviews. More Calls. More Customers.', 'Your Reputation Is Our Business', 'Helping Businesses Dominate Google Locally'];
  // Duplicate for seamless loop
  const duplicatedSlogans = [...slogans, ...slogans];
  return <div className="bg-blue-soft py-4 overflow-hidden flex items-center border-y border-blue/10" data-id="element-353">
      <motion.div className="flex whitespace-nowrap items-center" animate={{
      x: ['0%', '-50%']
    }} transition={{
      repeat: Infinity,
      ease: 'linear',
      duration: 30
    }} whileHover={{
      animationPlayState: 'paused'
    }} // Note: Framer motion doesn't natively pause on hover easily with this setup without complex state, using CSS approach or accepting continuous is better. We'll let it run continuously for smoothness.
    data-id="element-354">
        {duplicatedSlogans.map((slogan, index) => <div key={index} className="flex items-center mx-8" data-id="element-355">
            <span className="text-navy font-semibold text-sm md:text-base tracking-wide uppercase" data-id="element-356">
              {slogan}
            </span>
            <Star className="w-4 h-4 text-gold fill-current mx-8 opacity-50" data-id="element-357" />
          </div>)}
      </motion.div>
    </div>;
}